'use es6';

import { EMPTY_OBJECT } from 'DesignData/lib/object';
export default function Auth(state = EMPTY_OBJECT, action) {
  switch (action.type) {
    default:
      return state;
  }
}